import { devicesFr as rfcDevicesFr } from '@rfc/rfc-components-library/locales'

export const devicesFr = {
    ...rfcDevicesFr,
    actions: {
        ...rfcDevicesFr.actions,

        rdrChannels: {
            rdrChannelsText: ''
        },
        reassignCheckpoint: 'Affecter à un checkpoint',
        attachDeviceToOrganization: 'Attacher à un client',
        detachDeviceToOrganization: 'Détacher du client',
        changeDeviceType: "Change de type d'appareil"
    },
    checkpoints: {
        detectionsCount: 'Nombre de détections :'
    },

    cardContent: {
        checkpointAssociatedTitle: 'Checkpoint associé',
        eventAssociatedTitle: 'Evènement associé',
        noEventAssociated: 'Aucun évènement associé',
        noCheckpointAssociated: 'Aucun checkpoint associé'
    },
    configuration: {
        ...rfcDevicesFr.configuration,
        errors: {
            rangeError: 'La valeur doit être comprise entre {min} et {max}',
            excludedError: 'La valeur ne peut pas être {excluded}'
        },
        apiKey: "Clé d'API uRTime"
    },
    detail: {
        ...rfcDevicesFr.detail,
        detections: {
            ...rfcDevicesFr.detail.detections,
            table: {
                ...rfcDevicesFr.detail.detections.table,
                bib: 'Bib',
                checkpoint: 'Checkpoint',
                event: 'Evènement',
                event_filter: 'Event filter',
                timer_filter: 'Timer filter'
            }
        }
    },
    filters: {
        ...rfcDevicesFr.filters,
        checkpoint: 'Checkpoint',
        event: 'Évènement'
    },
    model: {
        ...rfcDevicesFr.model,
        checkpointName: 'Checkpoint associé',
        eventName: 'Evènement associé'
    },
    rental: {
        ...rfcDevicesFr.rental,
        infoTitle: 'En location',
        nextRentals: 'Locations à venir',
        unavailabilities: 'Indisponibilités',

        updateCurrentRentalAction: 'Modifier la location',
        updateCurrentRentalTitle: 'Modifier la location courante',
        updateCurrentRentalDescription:
            'Souhaitez-vous vraiment modifier la location courante ? Cette action est irréversible.',
        updateRentalApiSuccess: 'Location modifiée !',

        endCurrentRentalAction: 'Terminer la location',
        endCurrentRentalTitle: 'Terminer la location courante',
        endCurrentRentalDescription:
            "Souhaitez-vous vraiment terminer la location courante ? Cette action retirera les accès de l'appareil au locataire.",
        endRentalApiSuccess: 'Location terminée !'
    },
    table: {
        ...rfcDevicesFr.table,
        currentEventTitle: 'Evènement associé'
    },
    title: {
        checkpointTitle: 'Checkpoint',
        eventTitle: 'Évènement',
        checkpointAssociatedTitle: 'Checkpoint associé',
        currentEventTitle: 'Evènement associé',
        noEventAssociated: 'Aucun évènement associé'
    }
}
